module.exports = __webpack_public_path__ + "static/media/eduBlack.5d0dd1fb.svg";